import { APICore } from './apiCore'

const api = new APICore()

function updatePrintConf (params) {
  const baseUrl = '/print-conf'
  return api.updateWithFile(baseUrl, params)
}

export { updatePrintConf }
